module.exports = __webpack_public_path__ + "img/clock-arrow.ccc3011c.svg";